import { connect } from 'react-redux';
import StoveSelectionComponent from '../components/stoveSelectionComponent';
import { changeStove, stoveDescriptionChanged } from '../actions';
const mapStateToProps = (state, ownProps) => ({
  stoves:state.stoves.selectableStoves,
    selectedStove: state.benchModel.stove,
    showPrices: state.clientConfiguration.showPrices,
    prices: state.optionPricing.stoves,
    showDescription: state.stove.stove == "ownStove",
    showRemoveStoveBtn: state.clientConfiguration.allowRemovalOfStove
});

const mapDispatchToProps = (dispatch, ownProps) => ({
   stoveChanged:(e)=>{
   dispatch(changeStove(e.id || e));
    },
    descriptionChanged: (description) => {
        dispatch(stoveDescriptionChanged(description));
    }
});

const stoveSelectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StoveSelectionComponent);

export default stoveSelectionContainer;


